
const { ccclass, property, menu, requireComponent, executeInEditMode } = cc._decorator;

@ccclass
@requireComponent(cc.Label)
@menu('custom/GrayLable')
@executeInEditMode
export default class GrayLable extends cc.Component{
    
    protected _originalNodeColor: cc.Color
    protected _originalOutlineColor: cc.Color

    protected onEnable(){
        this._originalNodeColor = this.node.color
        this.node.color = this.calcGrayColor(this.node.color)
        let outLine = this.getComponent(cc.LabelOutline)
        if(outLine){
            this._originalOutlineColor = outLine.color
            outLine.color = this.calcGrayColor(outLine.color)
        }
    }

    protected onDisable(){
        this.node.color = this._originalNodeColor
        let outLine = this.getComponent(cc.LabelOutline)
        if(outLine && this._originalOutlineColor){            
            outLine.color = this._originalOutlineColor
        }
    }

    protected calcGrayColor(srcColor: cc.Color){
        let c = 0.299*srcColor.getR() + 0.587*srcColor.getG() + 0.184*srcColor.getB()
        c = Math.min(255, c)
        c = Math.max(0, c)
        return new cc.Color(c, c, c, srcColor.getA())
    }
}
